export default __webpack_public_path__ + "b7e5eff152eb0febbfae3e8a735763023aac9455/5d23014a563dca4f7a3a15ddbb31830f.png";